$('.form-select select').each(function(_, element){
    var that = $(element);

    that.select2({
        selectOnClose: true,
        minimumResultsForSearch: that.data('min-for-search') || 10
    });

    that.on('select2:opening', function() {
        setTimeout(function () { $('.select2-search__field').focus(); }, 100);
    });

    that.closest('form').on('reset', function() {
        window.setTimeout(function() {
            that.trigger('change');
        }, 100);
    });

    $(document).on('select2:opening select2:open', function() {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            setTimeout(function() {
                document.activeElement.blur();
            }, 1);
        }
    });
});
